import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getData, getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  formatDateToIST,
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";

import DesignModal from "../OrderHistoryModal";

import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";

import OrderdetailsModal from "../orderdetailsModal";
import AddExpertOffCanvance from "../AddExpertAssign";
import UpdateExpertOffCanvance from "../UpdateExpertAssign";
import OrderHistoryModal from "../OrderHistoryModal";
import ExpertOrderDetailsModal from "../ExpertOrderDetailsModal";

function UnshippedTable({
  user,
  OrderByOptions,
  activeTab,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [searchDesign, setSearchDesign] = useState("");
  // const [searchDate, setSearchDate] = useState("");
  // const [searchDateTo, setSearchDateTo] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();

  const [vendors, setVendors] = useState([]);
  const [vendorSearch, setVendorSearch] = useState("");
  const getDataAll = async () => {
    const response = await getData(
      `/admin/orders/order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.OrderConfirmed || ""
      }&storeCategory=${storeCategory}&design_id=${
        searchDesign.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${
        searchCustomer || ""
      }&customer_contact=${searchCustomerContact || ""}&vendor_id=${vendorSearch?.value || ""}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    await GetAllCounts();
  };

  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange]);

  useEffect(() => {
    if (activeTab === "Unshipped") {
      getDataAll();
    }
  }, [activeTab]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });

  const [showPaking, setShowPaking] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/order/update-status/${id}`, {
        order_status_id: status_id,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
      GetAllCounts();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Preparing || ""
          }&storeCategory=${storeCategory}&design_id=${
            searchDesign.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const [product, setDesign] = useState([]);

  const GetAllDesign = async () => {
    const response = await getData("/common/masters/design");
    if (response?.success) {
      setDesign(await Select2Data(response?.data, "design_id"));
    }
  };

  useEffect(() => {
    GetAllDesign();
  }, []);

  const [showExpertAssign, setShowExpertAssign] = useState({
    show: 0,
    data: {},
  });
  const [showExpertAssignUpdate, setShowExpertAssignUpdate] = useState({
    show: 0,
    data: {},
  });
  const [orderHistory, setOrderHistory] = useState({ show: 0, data: {} });
  const [expertOrderHistory, setExpertOrderHistory] = useState({
    show: 0,
    data: {},
  });

  const getAllVendors = async () => {
    const response = await getData("/common/masters/all-vendors");

    if (response?.success) {
      setVendors(await Select2Data(response?.data, "id"));
    }
  };

  useEffect(() => {
    getAllVendors();
  }, []);
  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end">
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setonPageChange(1);
                      getDataAll();
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setonPageChange(1);
                      getDataAll();
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Select Vendor</Form.Label>

              <Select
                isSearchable
                options={vendors}
                value={vendorSearch}
                placeholder="Select Vendor"
                onChange={(e) => {
                  setVendorSearch(e);
                  setonPageChange(1);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setonPageChange(1);
                    getDataAll();
                  }
                }}
                classNamePrefix="searchVendor"
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Select Design </Form.Label>
              <Select
                isSearchable
                options={product}
                value={searchDesign}
                placeholder="Select Design"
                onChange={(e) => {
                  setSearchDesign(e);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setonPageChange(1);
                    getDataAll();
                  }
                }}
                classNamePrefix="searchDesign"
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setonPageChange(1);
                    getDataAll();
                  }
                }}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setonPageChange(1);
                    getDataAll();
                  }
                }}
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
              <div className="Search me-2">
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
              <div className="Search-1">
                <button
                  type="button"
                  onClick={() => {
                    setSearchCustomerContact("");
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setSearchDesign("");
                    setVendorSearch("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>
            {/* <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <button
                className="btn btn-success"
                type="button"
                onClick={HandleDownload}
              >
                Download Excel
                <FontAwesomeIcon
                  icon="fa-solid fa-file-lines"
                  className="ms-2"
                />
              </button>
            </div> */}
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              {" "}
              <th className="sr-no">Sr. No. </th>
              <th>Order Date</th>
              <th>Order details</th>
              <th>Designs</th>
              <th className="total">Total</th>
              <th>Vendor Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td>
                  {" "}
                  <div className="order-id">{index + 1}</div>
                </td>
                <td className="order-date">
                  <div className="order-id">
                    {/* {calculateTimeAgo(item?.createdAt)} */}
                    {formatDateToIST(item?.createdAt)}
                  </div>
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-id text-highlight">
                    <strong> Invoice No : </strong>
                    {item?.invoice_no}
                  </div>

                  <div className="order-info">
                    <span className="text-highlight">
                      <strong> Name : </strong>
                      {item?.User?.name || "NA"}{" "}
                    </span>
                    <br></br>
                  </div>
                  <div className="order-info">
                    <span className="order-info">
                      <strong> Contact : </strong>
                      {item?.User?.contact_no}
                    </span>
                  </div>
                  <div className="order-info">
                    <span className="order-info">
                      <strong> Payment Method : </strong>
                      {item?.Order?.Payment_Method?.name}
                    </span>
                  </div>
                  <div className="order-info">
                    <span className="order-info">
                      <strong> Express Delivery : </strong>
                      {item?.express_delivery_status ? "yes" : "No"}
                    </span>
                  </div>
                  <div className="order-info">
                    <span className="order-info">
                      <strong> Total Kilometer : </strong>
                      {item?.total_kilometer || 0} Km
                    </span>
                  </div>
                  {item?.express_delivery_status && (
                    <div className="order-info">
                      <span className="order-info">
                        <strong> Express Time : </strong>
                        {item?.Express_Delivery_Slot?.name}
                      </span>
                    </div>
                  )}
                </td>

                <td className="order-details">
                  <span>
                    {" "}
                    <strong>Category :</strong>{" "}
                    {item?.Design?.Category?.name}{" "}
                  </span>
                  <br></br>
                  <span>
                    <strong>Sub Category :</strong>{" "}
                    {item?.Design?.Sub_Category?.name}{" "}
                  </span>
                  <br></br>
                  <span>
                    {" "}
                    <strong>Design :</strong> {item?.Design?.name}{" "}
                  </span>
                  <br></br>
                </td>
                <td className="order-details">
                  <div className="order-id">
                    <span>
                      <b>Sub Total</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>₹{Number(item?.price).toFixed(2)} /-</span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Coupon Discount</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>₹ {Number(item?.coupon_discount).toFixed(2)} /-</span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Offer Discount</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span> ₹{Number(item?.offer_discount).toFixed(2)} /-</span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Refer Discount</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span> ₹{Number(item?.refer_discount).toFixed(2)} /-</span>
                  </div>
                  <div className="order-id">
                    <span>
                      <b>Facility Charges</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span>
                      {" "}
                      ₹{Number(item?.platform_charges).toFixed(2)} /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Packing Charges</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span> ₹{Number(item?.packing_charges).toFixed(2)} /-</span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Total Tax</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span> ₹{Number(item?.total_tax).toFixed(2)} /-</span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Delivery Charges</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span>
                      {" "}
                      ₹{Number(item?.shipping_charges).toFixed(2)} /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Total Amount</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span> ₹{Number(item?.total_amount).toFixed(2)} /-</span>
                  </div>
                  <div className="order-id">
                    <span>
                      <b>Remaining Amount</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span>
                      {" "}
                      ₹{Number(item?.remaining_amount).toFixed(2)} /-
                    </span>
                  </div>
                </td>
                <td>
                  <>
                    <div className="text-highlight">
                      <span>
                        {item?.User_Address?.first_name}{" "}
                        {item?.User_Address?.last_name}
                      </span>
                    </div>

                    <div>
                      <div className="mt-3">
                        {" "}
                        <span>
                          {" "}
                          <strong>Vendor Name :</strong>{" "}
                          {item?.Vendor?.name}{" "}
                        </span>
                        <br></br>
                        <span>
                          {" "}
                          <strong>Vendor Contact :</strong>{" "}
                          {item?.Vendor?.contact_no}{" "}
                        </span>
                        <br></br>
                      </div>
                    </div>
                  </>
                </td>
                <td>{item.Order_status?.name}</td>
                <td>
                  {/* <div className="my-1">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        ChangeOrderStatus(
                          item?.id,
                          OrderStatusIds.OrderUnderQualityCheck,
                        )
                      }
                    >
                      {" "}
                      Send Order under Quality Check{" "}
                    </Button>
                  </div> */}
                  {item?.Order_Assign_Experts?.length > 0 ? (
                    <>
                      {" "}
                      {/* <div className="my-1">
                        <b>Experts</b> :{" "}
                        {item?.Order_Experts?.map(
                          (val) => val?.Expert?.name,
                        )?.join(", ")}
                      </div> */}
                      <div className="mt-1 mb-3">
                        <Button
                          className="action-btn active w-100"
                          onClick={() =>
                            setShowExpertAssignUpdate({
                              show: item?.id,
                              data: item,
                            })
                          }
                        >
                          Update Experts{" "}
                        </Button>
                      </div>
                    </>
                  ) : (
                    <div className="mt-1 mb-3">
                      <Button
                        className="action-btn active w-100"
                        onClick={() =>
                          setShowExpertAssign({
                            show: item?.id,
                            data: item,
                          })
                        }
                      >
                        {" "}
                        Assign Experts
                      </Button>
                    </div>
                  )}

                  <div className="my-1">
                    <Button
                      className="action-btn w-100"
                      onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                    >
                      Print Invoice
                    </Button>
                  </div>
                  <div className="mt-3">
                    <Button
                      className="action-btn active w-100"
                      onClick={() => {
                        setShowDetails({
                          show: item?.id,
                          data: item,
                        });
                      }}
                    >
                      View All Details
                    </Button>
                  </div>

                  <div className="mt-3">
                    <Button
                      className="action-btn active w-100"
                      onClick={() => {
                        setOrderHistory({
                          show: item?.id,
                          data: item,
                        });
                      }}
                    >
                      Order History
                    </Button>
                  </div>

                  <div className="mt-3">
                    <Button
                      className="action-btn active w-100"
                      onClick={() => {
                        setExpertOrderHistory({
                          show: item?.id,
                          data: item,
                        });
                      }}
                    >
                      Expert Order History
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>

      <AddExpertOffCanvance
        handleClose={() => {
          setShowExpertAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowExpertAssign({ show: 0, data: {} })}
        show={showExpertAssign?.show}
        data={showExpertAssign?.data}
      />

      <UpdateExpertOffCanvance
        handleClose={() => {
          setShowExpertAssignUpdate({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowExpertAssignUpdate({ show: 0, data: {} })}
        show={showExpertAssignUpdate?.show}
        data={showExpertAssignUpdate?.data}
      />
      <OrderHistoryModal
        handleClose={() => {
          setOrderHistory({ show: 0, data: {} });
        }}
        setShow={() => setOrderHistory({ show: 0, data: {} })}
        show={orderHistory?.show}
        data={orderHistory?.data}
      />

      <ExpertOrderDetailsModal
        handleClose={() => {
          setExpertOrderHistory({ show: 0, data: {} });
        }}
        setShow={() => setExpertOrderHistory({ show: 0, data: {} })}
        show={expertOrderHistory?.show}
        data={expertOrderHistory?.data}
      />

      <OrderdetailsModal
        show={showDetails.show}
        data={showDetails.data}
        handleClose={() => setShowDetails({ show: false, data: {} })}
      />
    </section>
  );
}

export default UnshippedTable;
